'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = exports.Button = undefined;

var _radio = require('./radio');

var _radio2 = _interopRequireDefault(_radio);

var _group = require('./group');

var _group2 = _interopRequireDefault(_group);

var _radioButton = require('./radioButton');

var _radioButton2 = _interopRequireDefault(_radioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_radio2["default"].Button = _radioButton2["default"];
_radio2["default"].Group = _group2["default"];
exports.Button = _radioButton2["default"];
exports.Group = _group2["default"];
exports["default"] = _radio2["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./components/radio/index.tsx
 ** module id = 78
 ** module chunks = 0 1
 **/